import { toPath } from '../routes'

export function reportShowPath(record) {
  let pathname = null

  if (!record?.id) return null

  if (isV2Report(record)) {
    pathname = toPath.remoteChecks.remoteCheck({ id: record.id })
  } else {
    pathname = toPath.reports.report({ id: record.id })
  }

  return pathname
}

export function reportEditPath(record) {
  let pathname = null

  if (!record?.id) {
    return null
  }

  if (isV2Report(record)) {
    pathname = toPath.remoteChecks.remoteCheck.edit({ id: record.id })
  } else {
    pathname = toPath.reports.report.edit({ id: record.id })
  }

  return pathname
}

function isV2Report(record) {
  return record.type === 'RemoteCheck' || record.version === 'v2'
}
